const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';

function getAdminPassword() {
  return localStorage.getItem('hockey_admin_password') || '';
}

export function setAdminPassword(pw) {
  localStorage.setItem('hockey_admin_password', pw);
}

export function clearAdminPassword() {
  localStorage.removeItem('hockey_admin_password');
}

export function isLoggedIn() {
  return !!getAdminPassword();
}

async function request(path, options = {}) {
  const headers = { 'x-admin-password': getAdminPassword(), ...(options.headers || {}) };
  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(`${API_URL}${path}`, { ...options, headers });
  const data = await res.json();
  if (!res.ok) {
    const err = new Error(data.error || 'request failed');
    err.detail = data.detail;
    err.errors = data.errors;
    err.status = res.status;
    throw err;
  }
  return data;
}

export async function importProducts(file) {
  const formData = new FormData();
  formData.append('file', file);
  return request('/admin/products/import', { method: 'POST', body: formData });
}

export async function listProducts() {
  return request('/admin/products');
}

export async function setProductActive(id, active) {
  return request(`/admin/products/${id}`, { method: 'PATCH', body: JSON.stringify({ active }) });
}

export async function updateProduct(id, fields) {
  const res = await fetch(`${API_URL}/admin/products/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'x-admin-password': getAdminPassword() },
    body: JSON.stringify(fields),
  });
  return res.json();
}

export async function updateVariant(id, fields) {
  return request(`/admin/variants/${id}`, { method: 'PATCH', body: JSON.stringify(fields) });
}

export async function listTeams() {
  return request('/admin/teams');
}

export async function createTeam(team) {
  return request('/admin/teams', { method: 'POST', body: JSON.stringify(team) });
}

export async function getTeam(id) {
  return request(`/admin/teams/${id}`);
}

export async function updateTeam(id, fields) {
  return request(`/admin/teams/${id}`, { method: 'PATCH', body: JSON.stringify(fields) });
}

export async function listTeamUsers(id) {
  return request(`/admin/teams/${id}/users`);
}

export async function listOrders() {
  const res = await fetch(`${API_URL}/admin/orders`, {
    headers: { 'x-admin-password': getAdminPassword() },
  });
  return res.json();
}

export async function updateOrderStatus(id, status) {
  const res = await fetch(`${API_URL}/admin/orders/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'x-admin-password': getAdminPassword() },
    body: JSON.stringify({ status }),
  });
  return res.json();
}

export async function uploadProductImage(id, file) {
  const formData = new FormData();
  formData.append('image', file);
  const res = await fetch(`${API_URL}/admin/products/${id}/image`, {
    method: 'POST',
    headers: { 'x-admin-password': getAdminPassword() },
    body: formData,
  });
  return res.json();
}



export async function deleteTeam(id) {
  const res = await fetch(`${API_URL}/admin/teams/${id}`, {
    method: 'DELETE',
    headers: { 'x-admin-password': getAdminPassword() },
  });
  return res.json();
}

export async function deleteAllTeamUsers(teamId) {
  const res = await fetch(`${API_URL}/admin/teams/${teamId}/users`, {
    method: 'DELETE',
    headers: { 'x-admin-password': getAdminPassword() },
  });
  return res.json();
}

export async function deleteTeamUser(teamId, userId) {
  const res = await fetch(`${API_URL}/admin/teams/${teamId}/users/${userId}`, {
    method: 'DELETE',
    headers: { 'x-admin-password': getAdminPassword() },
  });
  return res.json();
}

export async function uploadTeamLogo(id, file) {
  const formData = new FormData();
  formData.append('logo', file);
  const res = await fetch(`${API_URL}/admin/teams/${id}/logo`, {
    method: 'POST',
    headers: { 'x-admin-password': getAdminPassword() },
    body: formData,
  });
  return res.json();
}
